var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H25.9934C33.7254 0 39.9934 6.26801 39.9934 14V25.9934C39.9934 33.7254 33.7254 39.9934 25.9934 39.9934H14C6.26801 39.9934 0 33.7254 0 25.9934V14Z",
    fill: "#FEF2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 28.3287C14.5555 28.3287 14.1316 28.1531 13.8191 27.8406C13.5066 27.5281 13.3311 27.1042 13.3311 26.6623V13.3311C13.3311 12.8892 13.5066 12.4653 13.8191 12.1528C14.1316 11.8403 14.5555 11.6647 14.9974 11.6647H21.663C21.9268 11.6643 22.188 11.7161 22.4317 11.817C22.6753 11.918 22.8966 12.0661 23.0828 12.253L26.0723 15.2425C26.2596 15.4287 26.4082 15.6502 26.5095 15.8942C26.6107 16.1381 26.6626 16.3998 26.6622 16.6639V26.6623C26.6622 27.1042 26.4866 27.5281 26.1741 27.8406C25.8616 28.1531 25.4378 28.3287 24.9958 28.3287H14.9974Z",
    stroke: "#E7000B",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6631 11.6647V15.8307C21.6631 16.0517 21.7509 16.2636 21.9071 16.4199C22.0634 16.5761 22.2753 16.6639 22.4963 16.6639H26.6623",
    stroke: "#E7000B",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3302 17.4971H16.6638",
    stroke: "#E7000B",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3294 20.8299H16.6638",
    stroke: "#E7000B",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3294 24.1627H16.6638",
    stroke: "#E7000B",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white",
    transform: "translate(9.99829 9.99835)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCode);
export default __webpack_public_path__ + "static/media/error_code.3b8e5a5c898467c07da0d797e744cf6e.svg";
export { ForwardRef as ReactComponent };